import Link from "next/link";

export default function LinkCard({url = "/", parentClasses= "", overlayClasses = "", children, overLayProps = {}, ...otherProps}) {
    return (
        <Link href={url} className={`relative overflow-hidden rounded-[1.563rem] px-[1.375rem] pt-[1.625rem] bg-no-repeat bg-cover bg-center duration-300 hover:scale-105 ${parentClasses}`} {...otherProps}>
            <span className={`w-full h-full absolute left-0 top-0 ${overlayClasses}`} {...overLayProps} />
            <div className="relative">
                {children}
            </div>
        </Link>
    )
}
